export enum VerificationStatus {
  ALL = -1,
  ACTIVE = 1,
  INACTIVE = 0,
}
